import type { RouteObject } from 'react-router-dom'

import { Component as NotFound } from '@/modules/common/pages/NotFound'

import { CommonRoutePathsEnum } from './commonRouteConfig.types'

export const COMMON_ROUTES: RouteObject[] = [
  {
    element: <NotFound />,
    path: CommonRoutePathsEnum.NOT_FOUND,
  },
]
